import { Injectable } from '@angular/core';

@Injectable()
export class FindMatchService {
    compareTwoStrings(first, second) {
        first = first.replace(/\s+/g, '')
        second = second.replace(/\s+/g, '')
    
        if (!first.length && !second.length) return 1;                   // if both are empty strings
        if (!first.length || !second.length) return 0;                   // if only one is empty string
        if (first === second) return 1;       							 // identical
        if (first.length === 1 && second.length === 1) return 0;         // both are 1-letter strings
        if (first.length < 2 || second.length < 2) return 0;			 // if either is a 1-letter string
    
        let firstBigrams = new Map();
        for (let i = 0; i < first.length - 1; i++) {
            const bigram = first.substr(i, 2);
            const count = firstBigrams.has(bigram)
                ? firstBigrams.get(bigram) + 1
                : 1;
    
            firstBigrams.set(bigram, count);
        };
    
        let intersectionSize = 0;
        for (let i = 0; i < second.length - 1; i++) {
            const bigram = second.substr(i, 2);
            const count = firstBigrams.has(bigram)
                ? firstBigrams.get(bigram)
                : 0;
    
            if (count > 0) {
                firstBigrams.set(bigram, count - 1);
                intersectionSize++;
            }
        }
    
        return (2.0 * intersectionSize) / (first.length + second.length - 2);
    }
    
    findBestMatch(mainString: string, targetStrings: any[], key?: string) {
        if (!this.areArgsValid(mainString, targetStrings)) throw new Error('Bad arguments: First argument should be a string, second should be an array of strings');
        
        const ratings = [];
        let bestMatchIndex = 0;
    
        for (let i = 0; i < targetStrings.length; i++) {
            let currentTargetString;

            if(key) {
                currentTargetString = targetStrings[i][key];
            } else {
                currentTargetString = targetStrings[i];
            }

            const currentRating = this.compareTwoStrings(this.normalizeWords(mainString.toLowerCase()), this.normalizeWords(currentTargetString.toLowerCase()));
            ratings.push({target: currentTargetString, rating: currentRating})
            if (currentRating > ratings[bestMatchIndex].rating) {
                bestMatchIndex = i
            }
        }
        
        
        const bestMatch = ratings[bestMatchIndex]
        
        return { ratings, bestMatch, bestMatchIndex };
    }

    private normalizeWords(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }
    
    flattenDeep(arr) {
        return Array.isArray(arr) ? arr.reduce((a, b) => a.concat(this.flattenDeep(b)), []) : [arr];
    }
    
    areArgsValid(mainString, targetStrings) {
        if (typeof mainString !== 'string') return false;
        if (!Array.isArray(targetStrings)) return false;
        if (!targetStrings.length) return false;
        // if (targetStrings.find(s => typeof s !== 'string')) return false;
        return true;
    }
    
    letterPairs(str) {
        const pairs = [];
        for (let i = 0, max = str.length - 1; i < max; i++) pairs[i] = str.substring(i, i + 2);
        return pairs;
    }
    
    wordLetterPairs(str) {
        const pairs = str.toUpperCase().split(' ').map(this.letterPairs);
        return this.flattenDeep(pairs);
    }
}